
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Deep Milan </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class>
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                <p>GHRCACS, Nagpur, proudly organised Deep Milan, a vibrant celebration of lights, unity, and togetherness. Bringing together students, faculty, and traditions, this event marked a memorable evening filled with joy and festivity. </p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan1.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan1.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan2.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan2.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan3.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan3.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan4.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan4.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan5.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/deep-milan5.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
